import auth from "../../middlewares/auth";

export const cloudServerRoutes = [
    {
        path: '/cloud-servers',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/cloud_servers/CloudServerIndex.vue'),
        name: 'cloud_servers',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/create-cloud-server',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/cloud_servers/CreateCloudServerForm.vue'),
        name: 'create_cloud_server',
        meta: {
            middleware: [
                auth
            ]
        }
    },
]